import { map } from 'lodash';
import {
  FETCH_FAVORITE_SUCCEED,
  FETCH_FAVORITE_DETAIL_SUCCEED,
} from '../actions/favorite/action_types';

export default (
  state = {
    favorite: [],
    favoriteDetail: [],
  }, action,
) => {
  switch (action.type) {
    case FETCH_FAVORITE_SUCCEED:
      return {
        ...state,
        favorite: action.data,
      };

    case FETCH_FAVORITE_DETAIL_SUCCEED:
      return {
        ...state,
        favoriteDetail: map(action.data, (item) => {
          item.key = item.pubkey;
          item.list_coin_arr = map(item.list_coin, (value, key) => (
            { name_coin: key, value }
          ));
          return item;
        }),
      };

    default:
      return {
        ...state,
      };
  }
};
